import { render, staticRenderFns } from "./TeamBoard.vue?vue&type=template&id=06a69e57&scoped=true"
import script from "./TeamBoard.vue?vue&type=script&lang=js"
export * from "./TeamBoard.vue?vue&type=script&lang=js"
import style0 from "./TeamBoard.vue?vue&type=style&index=0&id=06a69e57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a69e57",
  null
  
)

export default component.exports